var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"mb-6",attrs:{"no-gutters":""}},_vm._l((_vm.components),function(component){return _c('v-col',{key:component.name},[_c(component,{tag:"component"})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }